import { handleActions } from 'redux-actions';

import * as commonReducers from './common';
import * as actions from '../actions/attachments';

const {
  create,
  fetch,
  remove,
} = commonReducers.operationTypes;

export const attachmentsReducer = handleActions(
  {
    // create
    [actions.createAttachmentsRequest]: commonReducers.commonRequestReducer(create),
    [actions.createAttachmentsFailure]: commonReducers.commonFailureReducer(create),
    [actions.createAttachmentsSuccess]: commonReducers.createSuccessReducer,

    // delete
    [actions.removeAttachmentRequest]: commonReducers.commonRequestReducer(remove),
    [actions.removeAttachmentFailure]: commonReducers.commonFailureReducer(remove),
    [actions.removeAttachmentSuccess]: commonReducers.deleteSuccessReducer,

    // fetch
    [actions.fetchAttachmentsRequest]: commonReducers.commonRequestReducer(fetch),
    [actions.fetchAttachmentsFailure]: commonReducers.commonFailureReducer(fetch),
    [actions.fetchAttachmentsSuccess]: commonReducers.fetchSuccessReducer,
  },
  {
    items: {},
    isFetching: false,
    isCreating: false,
    isRemoving: false,
  },
);



// WEBPACK FOOTER //
// ./src/redux/reducers/attachments.js